import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { time } from 'console';
import { ToastrService } from 'ngx-toastr';
import { MetodosPago } from '../../../entities/MetodosPago/MetodosPago';
import { MetodosPagoService } from '../services/metodos-pago.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-listar-metodos-pago',
  templateUrl: './listar-metodos-pago.component.html',
  styleUrls: ['./listar-metodos-pago.component.scss']
})
export class ListarMetodosPagoComponent {
  public metodos:MetodosPago[];
  constructor(private toastService: ToastrService,private metodosService:MetodosPagoService, private route:Router){

  }

  ngOnInit(){
    this.obtenerMetodos()
  }

  obtenerMetodos(){
     this.metodosService.obtenerMetodosPago().subscribe((result:MetodosPago[])=>{
       this.metodos = result;
       //console.log(this.metodos)
     })
  } 

  registrarNueva(){
    this.route.navigateByUrl('/pages/agregar-metodo-pago')
  }

  eliminarTarjeta(n){
    Swal.fire({
			title: 'Eliminar',
			text: `¿Está seguro que desea eliminar el método de pago ${n.name}?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then(
			(result) => {
				if (result.value) {
			this.metodosService.eliminarMetodoPago(n.idKonnecta).subscribe(
						(response) => {
							Swal.fire(
								'Eliminado!',
								'El método de pago ha sido eliminado.',
								'success'
							);
							this.obtenerMetodos();
						}, (error) => {
							Swal.fire(
								'Ops!',
								'Error al intentar eliminar el método de pago.',
								'error'
							);
						});
				}
			})
  }
}
